<!-- @format -->

<template>
  <div>
    <div class="ui attached message">
      <div class="header">Appearance</div>
    </div>
    <div class="ui attached segment">
      <div class="ui">
        <div class="ui">
          <strong> <label>More Likely Range</label></strong>

          <div class="ui ">
            <div class="ui ">
              <small> <label>Colour & Opacity</label></small
              ><br />
              <div class="ui labeled input">
                <div class="ui label">
                  <v-swatches
                    :trigger-style="{ width: '20px', height: '20px' }"
                    show-fallback
                    fallback-input-type="color"
                    popover-x="left"
                    @input="showApply = true"
                    v-model="appearanceSettings.appearanceSchema.graphColor"
                  ></v-swatches>
                </div>
                <input
                  @focus="showApply = true"
                  class="ui input"
                  v-model="
                    appearanceSettings.appearanceSchema.graphColorOpacity
                  "
                />
              </div>
              <small
                style="color: darkred"
                v-if="appearanceSettings.appearanceSchema.graphColorOpacity > 1"
                ><br />Hint: Opacity should be between 0 and 1
              </small>
            </div>
          </div>

          <br />

          <label><strong>Less Likely Range</strong></label>

          <div>
            <small> <label>Colour & Opacity</label></small
            ><br />
            <div class="ui labeled input">
              <div class="ui label">
                <v-swatches
                  @input="showApply = true"
                  :trigger-style="{ width: '20px', height: '20px' }"
                  show-fallback
                  fallback-input-type="color"
                  popover-x="left"
                  v-model="appearanceSettings.appearanceSchema.graphColorRange2"
                ></v-swatches>
              </div>
              <input
                @focus="showApply = true"
                class="ui input"
                v-model="appearanceSettings.appearanceSchema.graphColorOpacity2"
              />
            </div>
            <small
              style="color: darkred"
              v-if="appearanceSettings.appearanceSchema.graphColorOpacity2 > 1"
              ><br />Hint: Opacity should be between 0 and 1
            </small>
          </div>
          <br />
        </div>
      </div>
    </div>
    <div v-if="showApply" class="ui attached message">
      <sui-button
        :class="loading ? 'loading' : 'small primary'"
        primary
        @click.prevent="savePartnerDefaultSettings"
      >
        Save & Apply to All Plans</sui-button
      >
      <notifications group="plan" position="bottom center" />
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VSwatches from "vue-swatches";
import { getPartnerSettings, updatePartnerDefaultSettings } from "@/gateway";
export default {
  name: "Testing",
  components: { vSelect, VSwatches },
  props: [
    "moreLikelyZScore",
    "lessLikelyZScore",
    "showLowestProjectedOutcome",
    "appearanceSettings",
  ],
  data() {
    // 2.326 -- 99th percentile
    // 1.645 - 95th percentile
    // 1.282 - 90th percentile
    // 1.6449 - 85th percentile
    // 0.674 - 75h percentile
    // 0.8416 - 60th percenetile
    // 0.125 - 55th percentile
    return {
      showApply: false,
      zScores: [
        { text: "1st & 99th Percentile", value: 2.5758 },
        { text: "5th & 95th Percentile", value: 1.96 },
        { text: "10th & 90th Percentile", value: 1.6449 },
        { text: "15th & 85th Percentile", value: 1.4395 },
        { text: "25th & 75th Percentile", value: 1.1503 },
        { text: "40th & 60th Percentile", value: 0.8416 },
        { text: "45th & 55th Percentile", value: 0.7554 },
      ],
    };
  },
  computed: {},
  methods: {
    async savePartnerDefaultSettings() {
      this.loading = true;
      const response = await updatePartnerDefaultSettings({
        appearanceSettings: this.appearanceSettings,
      });
      if (response) {
        console.log("response", response);
        this.$notify({
          group: "plan",
          title: "ALL Plans' appearances updated",
          position: "bottom left",
          type: "success",
        });
        this.loading = false;
      }
    },

    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0");
    },
    async handleZScoreChanged(selected) {
      this.$emit("handleZScoreChanged", {
        moreLikelyZScore: this.moreLikelyZScore,
        lessLikelyZScore: this.lessLikelyZScore,
        showLowestProjectedOutcome: this.showLowestProjectedOutcome,
      });
    },

    async init() {
      if (!this.moreLikelyZScore) {
        const partnerSetResponse = await getPartnerSettings();
        console.log("getting partner settings");
        if (partnerSetResponse) {
          this.moreLikelyZScore =
            partnerSetResponse.partnerDefaultSettings.moreLikelyZScore;
          this.lessLikelyZScore =
            partnerSetResponse.partnerDefaultSettings.lessLikelyZScore;
          this.showLowestProjectedOutcome =
            partnerSetResponse.partnerDefaultSettings.showLowestProjectedOutcome;
        }
      }
      // this.riskProfile = this.riskProfiles[0];
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
